import { render, staticRenderFns } from "./plattransactiondetais-set-pwd.vue?vue&type=template&id=a76a5dbe&"
import script from "./plattransactiondetais-set-pwd.vue?vue&type=script&lang=js&"
export * from "./plattransactiondetais-set-pwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports